<template>
    <AppLayout>
        <div class="bg-white">
            <div class="pt-6">
                <nav aria-label="Breadcrumb">
                    <ol role="list"
                        class="mx-auto flex max-w-2xl items-center space-x-2 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                        <li v-for="breadcrumb in page.breadcrumbs" :key="breadcrumb.id">
                            <div class="flex items-center">
                                <a :href="breadcrumb.href" class="mr-2 text-sm font-medium text-ink-900">{{
                                    breadcrumb.name
                                    }}</a>
                                <svg width="16" height="20" viewBox="0 0 16 20" fill="currentColor" aria-hidden="true"
                                    class="h-5 w-4 text-ink-300">
                                    <path d="M5.697 4.34L8.98 16.532h1.327L7.025 4.341H5.697z" />
                                </svg>
                            </div>
                        </li>
                        <li class="text-sm">
                            <a href="#" aria-current="page" class="font-medium text-ink-500 hover:text-ink-600">{{
                                page.name }}</a>
                        </li>
                    </ol>
                </nav>

                <!-- page info -->
                <div
                    class="mx-auto max-w-2xl px-4 pt-10 pb-16 sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-3 lg:grid-rows-[auto_auto_1fr] lg:gap-x-8 lg:px-8 lg:pt-16 lg:pb-24">
                    <div class="lg:col-span-2 lg:border-r lg:border-ink-200 lg:pr-8">
                        <h1 class="font-display text-2xl font-bold tracking-tight text-ink-900 sm:text-3xl">{{ page.name }}</h1>
                    </div>

                    <!-- images -->
                    <div class="mt-4 lg:row-span-3 lg:mt-0">
                        <img :src="page.images[0].src" :alt="page.images[0].alt"
                            class="hidden w-full h-100 rounded-xl object-cover lg:block" />
                    </div>

                    <div v-html="contactUs ? contactUs.content : '...'"
                        class="py-10 lg:col-span-2 lg:col-start-1 lg:border-r lg:border-ink-200 lg:pt-6 lg:pr-8 lg:pb-16">
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/components/layouts/AppLayout.vue';
import { ref } from 'vue';
import { getContactUs } from '@/services/pageService';

const contactUs = ref(null);

const fetchContactUs = async () => {
    const response = await getContactUs();
    contactUs.value = response.data;
}

fetchContactUs();

const page = {
    name: 'Contact Us',
    breadcrumbs: [
        { id: 1, name: 'Home', href: '/' },
    ],
    images: [
        {
            src: '/images/courses/quran.jpg',
            alt: 'Page image 1',
        },
        {
            src: '/images/courses/quran.jpg',
            alt: 'Page image 2',
        },
    ],
}
</script>
